module.exports = "<div *ngIf=\"archive\">\n  <div class='col-md-12'*ngFor='let entry of archive.archive'>\n    <app-consultant-card  [archive]='entry'>\n    </app-consultant-card>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/archive/archive/archive-details/archive-details.component.html
// module id = ./src/app/views/archive/archive/archive-details/archive-details.component.html
// module chunks = main